import React from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { compose } from "recompose";
import Button from "@material-ui/core/Button";
import { withStyles, useTheme } from "@material-ui/core/styles";
import Add from "@material-ui/icons/Add";
import { showModal } from "../../../redux/actions";
import ModifySponsorModal from "./ModifySponsorModal";

const styles = {
  root: {
    background: "black",
  },
  input: {
    color: "white",
    backgroundColor: "rgb(36, 48, 65)",
  },
};

const AddSponsorButton = ({ onCreateClick, intl }) => {
  useTheme();

  return (
    <Button variant="contained" color="primary" onClick={() => onCreateClick()}>
      <Add
        style={{
          color: "white",
          marginRight: "5px",
          fontSize: "18px",
          fontWeight: "700",
        }}
      />
      {intl.formatMessage({ id: "app.sponsors.addSponsorButton" })}
    </Button>
  );
};

const mapDispatchToProps = (dispatch) => ({
  onCreateClick: () =>
    dispatch(
      showModal(ModifySponsorModal, {
        mode: 2,
      }),
    ),
});

const enhance = compose(
  connect(undefined, mapDispatchToProps),
  injectIntl,
  withStyles(styles),
);

export default enhance(AddSponsorButton);
